import SendIcon from "@mui/icons-material/Send";
import Button, { type ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export function SubmitButton({
  loading = false,
  disabled = false,
  onClick,
  children,
  ...rest
}: ButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      variant="contained"
      color="primary"
      type="submit"
      loadingPosition="start"
      loading={loading}
      startIcon={<SendIcon />}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children ?? t("Next:Core:Submit")}
    </Button>
  );
}
